export const EMITTER_SLOT_SPINS_STARS = {
    alpha: {
        start: 1,
        end: 0,
    },
    scale: {
        start: 1,
        end: 1,
        minimumScaleMultiplier: 1,
    },
    color: {
        start: "#ccebed",
        end: "#85e6f5",
    },
    speed: {
        start: 0,
        end: 0,
        minimumSpeedMultiplier: 1,
    },
    acceleration: {
        x: 0,
        y: 0,
    },
    maxSpeed: 0,
    startRotation: {
        min: 0,
        max: 0,
    },
    noRotation: false,
    rotationSpeed: {
        min: 0,
        max: 0,
    },
    lifetime: {
        min: 0.5,
        max: 0.5,
    },
    blendMode: "normal",
    frequency: 0.008,
    emitterLifetime: 0.31,
    maxParticles: 10,
    pos: {
        x: 0,
        y: 0,
    },
    addAtBack: false,
    spawnType: "rect",
    spawnRect: {
        x: -100,
        y: -100,
        w: 200,
        h: 200,
    },
};
